export const maskCpf = (value) => {
  const numericValue = value.replace(/\D/g, '').slice(0, 11)
  return numericValue
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
}

export const maskCnpj = (value) => {
  // 1. Converte para maiúsculas e remove tudo que NÃO for letra ou número
  const cleanValue = value
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 14)

  // 2. Aplica a máscara progressivamente (suporta digitação parcial)
  return cleanValue
    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
    .replace(
      /^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9])/,
      '$1.$2.$3/$4'
    )
    .replace(
      /^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})\/([A-Z0-9]{4})([A-Z0-9]{1,2})/,
      '$1.$2.$3/$4-$5'
    )
}

// Correção para identificação de CNPJ Alfa Numerico
export const maskCpfCnpj = (value) => {
  const hasLetters = /[A-Za-z]/.test(value)
  const cleanValue = value.replace(/[^A-Z0-9]/gi, '').toUpperCase()
  
  // CPF: só dígitos E <= 11 chars
  // CNPJ: tem letras OU > 11 chars
  if (!hasLetters && cleanValue.length <= 11) {
    return maskCpf(value)
  }
  return maskCnpj(value)
}

export const maskCep = (value) => {
  const numericValue = value.replace(/\D/g, '').slice(0, 8)
  return numericValue.replace(/(\d{5})(\d{1,3})/, '$1-$2')
}

export const maskPhone = (value) => {
  const numericValue = value.replace(/\D/g, '').slice(0, 11)
  return numericValue.length <= 10
    ? numericValue.replace(/(\d{2})(\d{4})(\d{1,4})$/, '($1) $2-$3')
    : numericValue.replace(/(\d{2})(\d{5})(\d{1,4})$/, '($1) $2-$3')
}

export const maskCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 4,
  }).format(value)

export const maskCurrencyToNumber = (value) => {
  if (typeof value !== 'string') return value || 0

  // Remove o "R$" e os pontos de milhar
  const cleanedValue = value.replace('R$', '').replace(/\./g, '')

  // Substitui a vírgula decimal por ponto
  const normalized = cleanedValue.replace(',', '.')

  const numberValue = parseFloat(normalized)

  return isNaN(numberValue) ? 0 : numberValue
}

export const maskInteger = (value) => {
  if (value === null || value === undefined) return ''
  const numberValue = Number(value)
  if (isNaN(numberValue)) return ''
  return numberValue.toLocaleString('pt-BR', { maximumFractionDigits: 0 })
}

export const removeMask = (value) => {
  if (typeof value === 'string') {
    return value.replace(/\D/g, '')
  }
  return value || ''
}

// Remove máscara preservando letras (para CNPJ alfanumérico)
export const removeMaskCpfCnpj = (value) => {
  if (typeof value === 'string') {
    return value.replace(/[^A-Z0-9]/gi, '').toUpperCase()
  }
  return value || ''
}
